import type { LucideIcon } from "lucide-react";
import { Handshake, HardHat, TreePine, Users } from "lucide-react";

export interface SocialValueCard {
  Icon: LucideIcon;
  title: string;
  body: string;
}

export const SOCIAL_VALUE_CARDS: SocialValueCard[] = [
  {
    Icon: Users,
    title: "Local Jobs",
    body: "We hire, train and supply from the local economy on framework projects.",
  },
  {
    Icon: HardHat,
    title: "Apprenticeships",
    body: "Apprentice involvement on installs where the programme allows, supporting the next generation of installers.",
  },
  {
    Icon: Handshake,
    title: "Local Supply Chain",
    body: "Preferential use of regional suppliers, scaffold and access partners.",
  },
  {
    Icon: TreePine,
    title: "Community Benefit",
    body: "Community-facing actions agreed up front with the buyer, reported on completion.",
  },
];
